import * as React from "react";

import { useEffect, useState } from "react";
import "../assets/darkthemebutton.css";
import { HiOutlineSun } from "react-icons/hi";
import { HiOutlineMoon } from "react-icons/hi";
import useTitanApp from "../hooks/useTitanApp";
import { toggleTheme } from "../dispatchers/appDispatchers";
import { Tooltip } from "@mui/material";

function DarkThemeButton() {
  const { appState } = useTitanApp();
  const { theme } = appState || {};

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  return (
    <Tooltip
      className="header-tooltip"
      title={`Toggle ${theme === "dark-theme" ? "Light" : "Night"} mode`}
      arrow
    >
      <div className="" onClick={toggleTheme}>
        {theme === "dark-theme" ? (
          <HiOutlineSun
            color={theme === "dark-theme" ? "#bdbdbd" : "#0a0a0a"}
          />
        ) : (
          <HiOutlineMoon
            color={theme === "dark-theme" ? "#bdbdbd" : "#0a0a0a"}
          />
        )}
      </div>
    </Tooltip>
  );
}

export default DarkThemeButton;
